import {Resource} from '~/app/core/common/resource';
import { HttpErrorResponse } from '@angular/common/http';
import {Serializer} from '~/app/core/common/serializers/serializer';
import {Observable, throwError} from 'rxjs';
import {map} from 'rxjs/operators';
import {QueryOptions} from '~/app/core/common/query-options';
import {BaseService} from '~/app/core/common/services/base.service';

export class ResourceService<T extends Resource> {
    constructor(public baseService: BaseService,
                private url: string,
                private endpoint: string,
                private serializer: Serializer,
    ) {

    }

    list(queryOptions: QueryOptions, username: string): Observable<T[]> {
        if (queryOptions == null) {
            return this.baseService.getHttpObject<T>(
                'queryOptionsNull',
                'resource-service',
                `${this.url}/${this.endpoint}/${username}`)
                .pipe(map((data: any) => this.convertData(data)));
        } else {
            return this.baseService.getHttp(
                'queryOptions',
                'resource-service',
                `${this.url}/${this.endpoint}?${queryOptions.toQueryString()}`)
                .pipe(map((data: any) => this.convertData(data)));
        }
    }

    public convertData(data: any, customSerializer?: Serializer): T[] {
        if (customSerializer !== null && customSerializer !== undefined) {
            return data.map(item => customSerializer.fromJson(item));
        } else {
            return data.map(item => this.serializer.fromJson(item));
        }
    }

    public handleError(error: HttpErrorResponse) {
        if (error.error) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error(
                `Backend
            returned;
            code ${error.status}, ` +
                `;
            body;
            was: ${error.error}`);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `;
            Backend;
            returned;
            code ${error.status}, ` +
                `;
            body;
            was: ${error.error}`);
        }
        // return an observable with a user-facing error message
        return throwError(error.error);
    }

}
